/**
 * Countdown Timer - Alpine.js data component for date countdown display
 *
 * Decomposes the time remaining until a target date into days, hours, minutes,
 * and seconds. Detects expiration and cleans up its interval on destroy.
 *
 * Usage (in Blade):
 *   x-data="countdownTimer(@js($targetDate))"
 *
 * @param {string|null} targetDate - ISO date string for the countdown target
 * @returns {object} Alpine data component
 */
export default function countdownTimer(targetDate) {
  return {
    targetDate,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isExpired: false,
    interval: null,

    init() {
      if (!this.targetDate) {
        this.isExpired = true;
        return;
      }
      this.updateCountdown();
      if (this.isExpired) return;
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    },

    updateCountdown() {
      const target = new Date(this.targetDate).getTime();
      const now = new Date().getTime();
      const distance = target - now;

      if (distance < 0) {
        this.isExpired = true;
        clearInterval(this.interval);
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
    },

    destroy() {
      if (this.interval) clearInterval(this.interval);
    },
  };
}
